<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">ACKNOWLEDGMENTS</span></p>
<p class="tni">My gratitude for their generous help with this book to my editor, Charles Spicer; to my literary agent, Natasha Kern; and to my partner, Merl Grossmeyer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?c9c2dd64